<template>
  <v-chip
    :pill='pill'
    :label='!pill'
    :x-small='small'
    :small='!small'
    :color='chipData.color'
    :dark='chipData.dark'
  >
    <v-icon left small>{{ chipData.icon }}</v-icon>
    {{ chipData.text }}
  </v-chip>
</template>

<script>

export default {
  name: 'invoice-status-chip',
  props: {
    pill: {
      required: false,
      type: Boolean,
      default: false
    },
    small: {
      required: false,
      type: Boolean,
      default: false
    },
    status: {
      required: true,
      type: String
    }
  },
  computed: {
    chipData () {
      let tmp = {}
      tmp.dark = false

      switch (this.status) {
        case 'unsent':
          tmp.text = 'Unsent'
          tmp.icon = 'mdi-send'
          tmp.color = 'info'
          break
        case 'archived':
          tmp.text = 'Archived'
          tmp.icon = 'mdi-archive'
          tmp.color = 'purple'
          tmp.dark = true
          break
        case 'unpaid':
          tmp.text = 'UN-paid'
          tmp.icon = 'mdi-alert-circle-outline'
          tmp.color = 'warning'
          break
        case 'paid':
          tmp.text = 'Paid'
          tmp.icon = 'mdi-checkbox-marked-circle-outline'
          tmp.color = 'success'
          break
        case 'overdue':
          tmp.text = 'OVERDUE'
          tmp.icon = 'mdi-alert'
          tmp.color = 'error'
          break
        case 'on_hold':
          tmp.text = 'On Hold'
          tmp.icon = this.$icons.hold.icon
          tmp.color = 'error'
          break
      }
      return tmp
    }
  }
}
</script>
